import { useEffect, useRef, useContext } from 'react';
import GMOptsContext from './gmOptsContext';
export function useUniqueId() {
  var idRef = useRef(null);

  if (idRef.current === null) {
    idRef.current = Math.random();
  }

  return idRef.current;
}
/**
 * React hook for accepting global markup options objects and sending them to a context provider to be merged together
 * @param {object} gmOptions - global markup options object
 */

var useGlobalMarkupOptions = function useGlobalMarkupOptions(gmOptions) {
  var id = useUniqueId();
  var context = useContext(GMOptsContext) || {};

  var emitChange = function emitChange() {
    var setGMOptions = context.setGMOptions;
    if (!setGMOptions) return;
    setGMOptions(id, gmOptions);
  };

  useEffect(function () {
    return function () {
      // componentWillUnmount
      var GlobalMarkupOptionsInstances = context.GlobalMarkupOptionsInstances;
      if (!GlobalMarkupOptionsInstances) return;
      GlobalMarkupOptionsInstances.remove(id);
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []); // useEffect doesn't run in SSR, so call emitChange here

  emitChange();
};

export default useGlobalMarkupOptions;